import { useParams } from "react-router-dom";
import { jwtDecoder } from "utils/jwtDecoder";

export const RoleBasedComponent = ({ staffComponent: StaffComponent, guestComponent: GuestComponent }) => {
  const { company } = useParams();
  const { companyIdx } = jwtDecoder(sessionStorage.getItem(company) || localStorage.getItem(company));

  return companyIdx === 1 ? StaffComponent : GuestComponent;
};
